<template>
  <div :class="rootClass" :style="rootStyle" :id="rendering?.dataSource">
    <ContentGrid :desktop-default-grid="[2, 20]" :mobile-default-grid="[1, 14]">
      <JssRichText class="news-detail-tag" :field="fields?.newsTag?.fields?.text" />
      <JssRichText class="news-detail-title" :field="fields?.newsTitle" tag="h1" />
      <div class="news-detail-share">
        <div class="news-detail-share-lt">
          <div
            class="news-detail-share-lt-item"
            v-if="fields?.newsDate?.value !== '0001-01-01T00:00:00Z'"
          >
            <Icon name="date" />
            <span class="news-detail-share-lt-item-desc">{{
              formatDate(fields?.newsDate?.value)
            }}</span>
          </div>
        </div>
        <div class="news-detail-share-rt">
          <button
            class="news-detail-share-rt-share"
            type="button"
            :aria-label="shareAriaLabel"
            @click="handleShare"
          >
            <Icon name="share" />
          </button>
        </div>
      </div>
      <JssRichText class="news-detail-body" :field="fields?.newsBody" tag="div" />
    </ContentGrid>
  </div>
</template>

<script>
import utils from '@/utils';
import { shareToLinkedIn } from '@/utils/dom-utils';

export default {
  name: 'NewsDetail',
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    rendering: {
      type: Object,
    },
    page: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const rootClass = utils.overall.baseComClass(props.fields, 'news-detail');

    const rootStyle = utils.overall.baseComStyle(props.fields);

    const formatDate = (dateStr) => {
      if (!dateStr) return '';
      const months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ];
      const date = new Date(dateStr);
      if (isNaN(date.getTime())) return dateStr;
      const month = months[date.getMonth()];
      const day = date.getDate();
      const year = date.getFullYear();
      return `${month} ${day}, ${year}`;
    };

    const getShareUrl = () => {
      if (typeof window === 'undefined') return '';
      return window.location.href;
    };

    const shareAriaLabel = 'Share on LinkedIn';

    const handleShare = () => {
      const url = getShareUrl();
      shareToLinkedIn(url);
    };

    return {
      rootClass,
      rootStyle,
      formatDate,
      shareAriaLabel,
      handleShare,
    };
  },
};
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/functions';
@import '../../styles/mixins';

.news-detail {
  position: relative;
  width: 100%;
  padding: 40px 0 0;

  &-tag {
    font-size: 14px;
    line-height: 1.4;
    color: $blue-night;
    padding: 4px 16px;
    background: #f1f4f1;
    border-radius: 32px;
    display: inline-block;
  }

  &-title {
    margin-top: 16px;
    font-size: 16px;
  }

  &-share {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 16px;

    &-lt {
      display: flex;
      align-items: center;
      gap: 16px;

      &-item {
        display: flex;
        align-items: center;
        gap: 4px;
        svg {
          fill: transparent;
        }
        &-desc {
          font-size: 14px;
          line-height: 1.4;
          color: #656565;
        }
      }
    }

    &-rt {
      display: flex;
      align-items: center;

      &-share {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        justify-self: end;
        width: 40px;
        height: 40px;
        padding: 0;
        color: #111111;
        background: transparent;
        border: 0;
        cursor: pointer;

        svg {
          width: 32px;
          height: 32px;
        }

        &:hover,
        &:focus-visible {
          color: #739b78;
          outline: none;
        }
      }

      &-button {
        margin-left: 16px;
      }
    }
  }

  &-body {
    margin-top: 24px;
    img {
      max-width: 100% !important;
    }
    p {
      font-size: 16px;
    }
    h2 {
      font-size: 22px;
      color: $blue-night;
      margin: 16px 0;
    }
    a {
      color: $blue-night;
    }
  }

  @include tablet-landscape {
    padding: 60px 0 0;

    &-title {
      margin-top: 24px;
      font-size: 32px;
    }

    &-share {
      margin-top: 30px;
    }

    &-body {
      margin-top: 40px;
    }
  }
}
</style>
